// extracted by mini-css-extract-plugin
export default {"host":"TagsViewer_host__4JJE8","invalidTag":"TagsViewer_invalidTag__nUkQ2"};